import { render, staticRenderFns } from "./WoodenPanel.vue?vue&type=template&id=5163b324&"
import script from "./WoodenPanel.vue?vue&type=script&lang=js&"
export * from "./WoodenPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports